/**
 * Etiquetas en español para el valor de "¿Cómo nos conociste?" (leadSource / relationToStudent).
 * Acepta tanto valores con guión bajo (pagina_web) como guión (pagina-web).
 */
const LEAD_SOURCE_LABELS: Record<string, string> = {
  recomendacion: 'Recomendación de un amigo o familiar',
  hermano: 'Hermano(a)',
  pagina_web: 'Página web',
  embajador: 'Embajador(a)',
  instagram: 'Instagram',
  profesor: 'Profesor(a)',
  centro_alumnos: 'Centro de alumnos',
};

/**
 * Devuelve la etiqueta legible para un valor de leadSource/relationToStudent.
 * Si el valor viene con guión (ej. pagina-web), se normaliza a guión bajo para el lookup.
 */
export function getLeadSourceLabel(value: string | null | undefined): string {
  if (value == null || value === '') return '-';
  const normalized = value.replace(/-/g, '_');
  return LEAD_SOURCE_LABELS[normalized] ?? value;
}
